<hyperkit-dialog
  class="hyperkit-component"
  [headerText]="
    submitted
      ? 'Your Community Access has been reactivated!'
      : 'Reactivate Community Access'
  "
>
  <div class="wrapper">
    @if (!submitted) {
      <div>
        <hyperkit-typography variant="body" size="md" align="left" color="body"
          >To regain access, tell us a little bit about why you're using
          HUNTER.</hyperkit-typography
        >
        <form (ngSubmit)="onReactivate()">
          <div [formGroup]="checkboxGroup">
            @for (item of reactivationReasons; track item) {
              <div class="reason">
                <hyperkit-checkbox
                  #checkedState
                  [formControlName]="item"
                  [value]="item"
                  [label]="item"
                >
                </hyperkit-checkbox>
              </div>
            }
          </div>
          <div [formGroup]="form">
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >Additional Info</hyperkit-typography
            >
            <hyperkit-input
              formControlName="additionalInfo"
              placeholder="Add any other details you'd like us to know"
            ></hyperkit-input>
          </div>
          <div>
            @if (error) {
              <hyperkit-error [error]="error"></hyperkit-error>
            }
          </div>
          <hyperkit-button
            size="small"
            color="tertiary"
            text="Reactivate"
            type="submit"
            [disabled]="!form.valid"
          ></hyperkit-button>
        </form>
      </div>
    }
    @if (submitted) {
      <div class="submitted">
        <hyperkit-typography variant="body" size="md" align="left" color="body">
          You have recieved an additional 30 days of Community access to the
          HUNTER platform.</hyperkit-typography
        >
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Return to Research"
          (click)="returnToResearch()"
        ></hyperkit-button>
      </div>
    }
  </div>
</hyperkit-dialog>
